// CE-04g-UI-chrome-2 — single source of truth for the multi-instance policy
// shared between TradeChart (handleAdd duplicate-instance guard) and
// IndicatorAccordion (add-dropdown gray-out rule). Lives in its own
// module so both consumers can import without a circular dep (TradeChart
// itself imports IndicatorAccordion).
//
// AVWAP keeps the one-instance cap this slice — multi-instance AVWAP ships
// in CE-04e via point-and-click anchors.

export const MULTI_INSTANCE_KINDS = new Set(['sma', 'ema'])
